import { MonthAvailability } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

export type MonthAvailabilityResult = {
  isMonthAvailableOnSpecificDay: boolean;
  isMonthAvailableEveryDay: boolean;
  isMonthAvailableWithinDateRange: boolean;
};

export const getMonthAvailability = (
  isMonthAvailable: boolean,
  monthAvailableOn: MonthAvailability
): MonthAvailabilityResult => {
  return {
    isMonthAvailableOnSpecificDay:
      isMonthAvailable &&
      monthAvailableOn === MonthAvailability.ON_SPECIFIC_DAY,
    isMonthAvailableEveryDay:
      isMonthAvailable && monthAvailableOn === MonthAvailability.EVERY_DAY,
    isMonthAvailableWithinDateRange:
      isMonthAvailable &&
      monthAvailableOn === MonthAvailability.WITHIN_DATE_RANGE,
  };
};
